import $axios from "../api/accessor";
import { $api } from "../api/api";

export const ServiceDebtService = {
  async getDebts(status: "all" | "unpaid" | "paid" = "all", url?: string) {
    try {
      const response = await $axios.get(
        url || $api("service_debts", { status })
      );
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async getSummary() {
    try {
      const response = await $axios.get($api("service_debts_summary"));
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async payWithBalance(debtIds?: number[], packageId?: number) {
    try {
      const response = await $axios.post($api("service_debts_pay_balance"), {
        debt_ids: debtIds,
        package_id: packageId,
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async payWithCard(cardId: number, debtIds?: number[], packageId?: number) {
    try {
      const response = await $axios.post($api("service_debts_pay_card"), {
        card_id: cardId,
        debt_ids: debtIds,
        package_id: packageId,
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async payDirect(debtIds?: number[], packageId?: number) {
    try {
      const response = await $axios.post($api("service_debts_pay_direct"), {
        debt_ids: debtIds,
        package_id: packageId,
      });
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
